import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'set-password',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login-v2',
    loadComponent: () =>
      import('./components/login-v2/login-v2.component').then(
        (m) => m.LoginV2Component,
      ),
  },
  {
    path: 'loading-screen',
    loadComponent: () =>
      import('./shared/loading-screen/loading-screen.component').then(
        (m) => m.LoadingScreenComponent,
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'set-password/:userId',
    loadComponent: () =>
      import('./components/set-password/set-password.component').then(
        (m) => m.SetPasswordComponent,
      ),
  },
  {
    path: 'passwort-vergessen-anfordern',
    loadComponent: () =>
      import('./components/forget-password/forget-password.component').then(
        (m) => m.ForgetPasswordComponent,
      ),
  },
  {
    path: 'passwort-vergessen',
    loadComponent: () =>
      import('./components/set-forget-password/set-forget-password.component').then(
        (m) => m.SetForgetPasswordComponent,
      ),
  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];
